export default function formatarNumero(numero, options) {
  if (!isNaN(numero)) {
    return new Intl.NumberFormat("pt-BR", options).format(numero);
  } else {
    return null;
  }
}